import React, { useState } from 'react';
import { motion } from 'framer-motion';
import ImageLightbox from '../Services/ImageLightbox';
import { metadata } from '../../mdx/services/wedding-photography.mdx';
import './Weddingphotos.css';

const Weddingphotos = () => {
  const images = metadata.images || [];
  const [selectedIdx, setSelectedIdx] = useState(null);
  const move = (step) => setSelectedIdx((current) => (current + step + images.length) % images.length);
  return (
    <section className="wedding-photos">
      <div className="wedding-photos__container">
        <h2 className="wedding-photos__title">Wedding Memories</h2>
        <p className="wedding-photos__subtitle">Capturing your special moments</p>
        <div className="wedding-photos__grid">
          {images.map((src, index) => <motion.figure key={src} className="wedding-photos__item" initial={{ opacity: 0, y: 80 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} onClick={() => setSelectedIdx(index)}><img src={`${process.env.PUBLIC_URL}${src}`} alt={`Wedding memory ${index + 1}`} loading="lazy" /><div className="wedding-photos__item-overlay"><span className="wedding-photos__item-number">{index + 1}</span></div></motion.figure>)}
        </div>
      </div>
      <ImageLightbox images={images} index={selectedIdx} onClose={() => setSelectedIdx(null)} onChange={move} />
    </section>
  );
};

export default Weddingphotos;
